import React from "react";

import { faLinkHorizontal, faPencil, faTrashCan } from "@fortawesome/pro-regular-svg-icons";

import { Text } from "@performyard/py-components";

import IconButton from "../../../../components/Button/IconButton";
// Components
import Icon from "../../../../components/Icon";
import Link from "../../../../components/Link";

// styles
import css from "../../CompanyResources.module.scss";
import { LinkRowType } from "../../schema";

const LinkRow = (props: LinkRowType) => {
	return (
		<div data-testid="link-row" className={css.row}>
			<div
				data-testid="link-row-contents-base"
				className={css.clickable}
				onClick={props.incrementCompanyLinkScore}
			>
				<Link href={props.url} isExternal={true}>
					<Icon icon={faLinkHorizontal} size="small" className={css.linkIcon} />
				</Link>
				{/*
					min-w-0 lets the anchor shrink below its nowrap content so the text can ellipsize.

					weight: both rows were `light` (300) under the legacy Text. py-components `Text` has no
					`light` weight — its fontWeightsMap offers regular/semi-bold/bold — so this is a
					deliberate 300 → 400 change, accepted rather than reproduced with a raw `font-light`
					class that tailwind-merge would not reconcile against the cva `font-regular`.
				*/}
				<Link href={props.url} isExternal={true} className="min-w-0">
					<Text
						wrap={false}
						size="paragraph-3"
						weight="regular"
						dangerouslySetClassName={`${css.mr8} py-text-truncate max-w-[500px]`}
					>
						{props.title ? props.title : props.url}
					</Text>
				</Link>
				<Link href={props.url} isExternal={true} className="min-w-0">
					<Text
						wrap={false}
						size="paragraph-3"
						weight="regular"
						dangerouslySetClassName={`${css.mr8} py-text-truncate max-w-[500px]`}
					>
						{props.description}
					</Text>
				</Link>
			</div>
			<div className={css.spacer} />
			{props.canManage && (
				<div data-testid="link-row-admin-buttons" className={css.buttonsContainer}>
					<IconButton
						icon={faPencil}
						onClick={props.onSelectEdit}
						className={css.editIcon}
						aria-label="Edit link"
					/>
					<IconButton
						icon={faTrashCan}
						onClick={props.onSelectDelete}
						className={css.deleteIcon}
						aria-label="Delete link"
					/>
				</div>
			)}
		</div>
	);
};

export default LinkRow;
